__turbopack_context__.v({
  "table": "kFWiBG_table",
});
